import React, { useState, useEffect, useRef } from "react";
import { instance2 } from "../../utils/axiosInstance";
import DatePicker from "react-datepicker";
import {formatNumber} from "../../numberingformat"
import { id } from "date-fns/locale";
import { Separator } from "src/components/shadcn/separator";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/shadcn/tabs";

export default function Dashboard5() {
  const [data, setData] = useState([]);
  const [dataIngredient, setDataIngredient] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const kitchenId = localStorage?.getItem("kitchenId");

  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, "0");
    const day = String(thedate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchDishData = async (date) => {
    try {
      const response = await instance2.get(
        `/today_dish/${kitchenId}/${localDateString(date)}`,
      );
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching today_dish:", error);
    }
  };

  const fetchIngredientData = async (date) => {
    try {
      const response = await instance2.get(
        `/today_ingredient/${kitchenId}/${localDateString(date)}`,
      );
      setDataIngredient(response.data || []);
    } catch (error) {
      console.error("Error fetching today_ingredient:", error);
    }
  };

  useEffect(() => {
    fetchDishData(selectedDate);
    fetchIngredientData(selectedDate);
  }, [selectedDate]);

  const CustomDayInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
      type="button"
      onClick={onClick}
      ref={ref}
      className="bg-yellow-500 text-white font-bold px-4 py-2 w-full whitespace-nowrap hover:bg-yellow-400"
    >
      {value}
    </button>
  ));

  return (
    <div className="flex flex-col h-full w-full">
      <div className="grid grid-rows-2 py-6 gap-1 w-full">
        <p className="text-xl sm:text-2xl font-medium text-center w-full">
          Menu Hari Ini
        </p>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="eeee, dd MMMM yyyy"
          locale="id"
          popperPlacement="bottom-start"
          customInput={<CustomDayInput />}
        />
      </div>

      <Tabs className="w-full px-4 h-full" defaultValue="menu">
        <TabsList className="w-full">
          <TabsTrigger value="menu">Menu</TabsTrigger>
          <TabsTrigger value="bahan">Bahan</TabsTrigger>
        </TabsList>
        <TabsContent className="space-y-4 px-2 pt-4 pb-8" value="menu">
          {data && data.length > 0 ? (
            <div className="grid grid-cols-2 gap-3">
              {data.map((item) => (
                <div key={item.dish_id} className="flex flex-col gap-0 text-sm">
                  <span className="font-semibold">{item.dish_name}</span>
                  <span className="font-light text-xs text-neutral-500 capitalize">
                    {item.category_name}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p>Tidak ada data yang tersedia</p>
          )}
        </TabsContent>
        <TabsContent className="space-y-4 px-2 pt-4 pb-8" value="bahan">
          {dataIngredient && dataIngredient.length > 0 ? (
            <div className="grid grid-cols-1 xs:grid-cols-3 gap-3 py-0">
              {dataIngredient.map((ingredient) =>
                Boolean(ingredient.ingredient_name) ? (
                  <div
                    key={ingredient.ingredient_id}
                    className="flex flex-col gap-0 text-sm"
                  >
                    <span className="font-semibold">
                      {ingredient.ingredient_name}
                    </span>
                    <span className="font-light text-xs text-neutral-500">
                      {formatNumber(ingredient.qty)} {ingredient.uoq_code}
                    </span>
                  </div>
                ) : null,
              )}
            </div>
          ) : (
            <p>Tidak ada data yang tersedia</p>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
